import { ReactElement, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth.context';
import usePageTracking from '../hooks/usePageTracking';

/**
 * ProtectedRoute component to render protected pages if authenticated.
 * @returns - A React element representing the Procard component.
 */
export default function ProtectedRoute(): ReactElement {
  const navigate = useNavigate();
  usePageTracking();
  const { authUser, loading } = useAuth();

  useEffect(() => {
    if (!loading && !authUser) {
      navigate('/auth/login');
    }
  }, [authUser, loading]);

  return <Outlet />;
}
